import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Roles } from '../shared/Enums/Roles.enum';
import Keycloak from 'keycloak-js';

const isCaseAssigned = async (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const keycloak = inject(Keycloak);
  const router = inject(Router);
  if(!authenticated || !grantedRoles.resourceRoles['portal-app']) {
    keycloak.clearToken();
    return keycloak.login().then(() => false);
  }

  if(grantedRoles.resourceRoles['portal-app'].some(x => x.includes(Roles.PortalUserNotBinded))) {
    return true;
  }

  router.navigate(['']);
  return false;
};

export const canActivateCaseAssignment = createAuthGuard<CanActivateFn>(isCaseAssigned);